import { clsx } from "clsx";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

/**
 * Merge class names conditionally
 */
export function cn(...classes) {
  return clsx(...classes);
}

/**
 * Format date to dd/mm/yyyy using French locale
 */
export function formatDate(dateStr) {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    return format(date, "dd/MM/yyyy", { locale: fr });
  } catch {
    return dateStr;
  }
}

/**
 * Format amount to French euros (XXX XXX €)
 */
export function formatEuros(amount) {
  if (amount === null || amount === undefined) return "0 €";
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Map StatutDossier enum values to French labels
 */
export function statusLabel(statut) {
  const statusMap = {
    brouillon: "Brouillon",
    en_cours: "En cours",
    termine: "Terminé",
    genere: "Généré",
    envoye: "Envoyé",
  };
  return statusMap[statut] || statut;
}

/**
 * Map a construction year to the corresponding epoque_construction enum value
 */
export function anneeToEpoque(annee) {
  const y = Number(annee)
  if (!y || isNaN(y)) return null
  if (y < 1850) return 'avant_1850'
  if (y <= 1913) return '1850_1913'
  if (y <= 1947) return '1914_1947'
  if (y <= 1969) return '1948_1969'
  if (y <= 1980) return '1970_1980'
  if (y <= 1990) return '1981_1990'
  if (y <= 2000) return '1991_2000'
  if (y <= 2010) return '2001_2010'
  if (y <= 2020) return '2011_2020'
  return '2021_plus'
}
